import { useParams } from 'react-router';
import React from 'react';
import CreateClinicMasterProduct from '../components/CreateClinicMasterProduct/CreateClinicMasterProduct';

interface Params {
  clinicId: string;
}

const CreateClinicMasterProductContainer = () => {
  const { clinicId } = useParams<Params>();

  return <CreateClinicMasterProduct clinicId={clinicId} />;
};

export default CreateClinicMasterProductContainer;
